// users account origin field options
export const SELF_SIGNUP = 'SELF_SIGNUP';
export const IMPORTED_FROM_SALESFORCE = 'IMPORTED_FROM_SALESFORCE';
export const CREATED_BY_ADMIN_USER = 'CREATED_BY_ADMIN_USER';
export const ADDED_BY_PARENT = 'ADDED_BY_PARENT';
export const ADDED_BY_CHILD = 'ADDED_BY_CHILD';
export const SELF_ENROLLED = 'SELF_ENROLLED';
export const ENROLLED_BY_PARENT = 'ENROLLED_BY_PARENT';
export const ADDED_BY_FACILITATOR = 'ADDED_BY_FACILITATOR';
